import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Phase 12 — public beta status (cached per page load). */
let cache = null;
let inflight = null;

export const useBetaStatus = () => {
  const [beta, setBeta] = useState(cache);
  useEffect(() => {
    if (cache) return;
    if (!inflight) {
      inflight = api.get("/public/beta/status")
        .then((r) => { cache = r.data; return cache; })
        .catch(() => null);
    }
    let mounted = true;
    inflight.then((d) => { if (mounted && d) setBeta(d); });
    return () => { mounted = false; };
  }, []);
  return beta;
};

/** Privacy-safe aggregate metric ping — no IDs, no IPs, never linked to declarations. */
export const betaMetric = (event, extra = {}) => {
  try {
    const w = window.innerWidth;
    const device = w < 640 ? "mobile" : w < 1024 ? "tablet" : "desktop";
    let referral = null;
    try {
      if (document.referrer) {
        const host = new URL(document.referrer).hostname;
        if (host && host !== window.location.hostname) referral = host;
      }
    } catch { /* ignore */ }
    api.post("/public/beta/metric", {
      event, page: window.location.pathname, device, referral, ...extra,
    }).catch(() => {});
  } catch { /* never break the page for analytics */ }
};
